"use client";

import { useTranslations } from "next-intl";
import { cn } from "@/lib/utils";

interface StockIndicatorProps {
	/** null = unlimited stock (inventory tracking disabled) */
	quantityAvailable: number | null;
}

export function StockIndicator({ quantityAvailable }: StockIndicatorProps) {
	const t = useTranslations("stock");

	// null = tracking disabled → treat as in-stock (unlimited)
	if (quantityAvailable === null) {
		return (
			<div className="flex items-center gap-2 text-sm">
				<span className="h-2 w-2 rounded-full bg-emerald-500" />
				<span className="font-medium text-emerald-600 dark:text-emerald-400">{t("inStock")}</span>
			</div>
		);
	}

	if (quantityAvailable === 0) {
		return (
			<div className="flex items-center gap-2 text-sm">
				<span className="h-2 w-2 rounded-full bg-destructive" />
				<span className="font-medium text-destructive">{t("outOfStock")}</span>
			</div>
		);
	}

	if (quantityAvailable <= 5) {
		return (
			<div className="flex items-center gap-2 text-sm">
				<span className="h-2 w-2 rounded-full bg-amber-500" />
				<span className={cn("font-medium text-amber-600 dark:text-amber-400")}>
					{t("lowStock", { count: quantityAvailable })}
				</span>
			</div>
		);
	}

	return (
		<div className="flex items-center gap-2 text-sm">
			<span className="h-2 w-2 rounded-full bg-emerald-500" />
			<span className="font-medium text-emerald-600 dark:text-emerald-400">{t("inStock")}</span>
		</div>
	);
}
